<template>
  <!-- Régime -->
  <InputSelect
    label="Régime obligatoire"
    :slug="regimeSlug"
    :model="regime"
    :options="availableRegimes"
    :v$="v$"
    @input="$emit('updateRegime', $event.target.value)"
  />

  <!-- Statut -->
  <InputSelect
    v-if="!!regime"
    label="Statut"
    :slug="activiteSlug"
    :model="activite"
    :options="availableActivites"
    :v$="v$"
    @input="$emit('updateActivite', $event.target.value)"
  />

  <!-- Profession -->
  <InputSelect
    v-if="!!regime && !!activite"
    label="Profession"
    :slug="professionSlug"
    :model="profession"
    :options="availableProfessions"
    :v$="v$"
    @input="$emit('updateProfession', $event.target.value)"
  />

  <!-- Option Madelin -->
  <input-radio
    v-if="displayMadelin === '1'"
    label="Souhaitez-vous bénéficier de la loi Madelin ?"
    :slug="madelinSlug"
    :model="madelin"
    :options="[{'label': 'Oui', 'value': '1'}, {'label': 'Non', 'value': '2'}]"
    :v$="v$"
    @input="$emit('updateMadelin', $event.target.value)"
  />
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { requiredIf } from '@vuelidate/validators'
import {computed } from "vue";
import InputSelect from "src/modules/shared/components/Form/InputSelect";
import {required, serverError} from "src/modules/shared/validators/validators";
import InputRadio from 'src/modules/shared/components/Form/InputRadio';

export default {
  name: "RegimeSelectForm",
  components: {
    InputRadio,
    InputSelect
  },
  props: {
    regimes: {
      type: Object,
      default: () => {}
    },
    regime: {
      type: String,
      required: true
    },
    activite: {
      type: String,
      required: true
    },
    profession: {
      type: String,
      required: true
    },
    regimeSlug: {
      type: String,
      required: true
    },
    activiteSlug: {
      type: String,
      required: true
    },
    professionSlug: {
      type: String,
      required: true
    },
    madelinSlug: {
      type: String,
      required: true
    },
    madelin: {
      type: String,
      required: true
    },
    displayMadelin: {
      type: String,
      required: true
    },
    serverErrors: {
      type: Array,
      required: true
    },
  },
  emits: [
    'updateRegime',
    'updateActivite',
    'updateProfession',
    'updateMadelin'
  ],
  setup (props) {
    const validations = computed(() => ({
      regime: {
        required,
        serverError: serverError(props, props.regimeSlug)
      },
      activite: {
        required,
        serverError: serverError(props, props.activiteSlug)
      },
      profession: {
        required,
        serverError: serverError(props, props.professionSlug)
      },
      madelin: {
        // TODO : Bug to resolve
        requiredIf: requiredIf(props.displayMadelin && false),
        serverError: serverError(props, props.madelinSlug)
      }
    }))

    const v$ = useVuelidate(validations, props)

    return { v$ }
  },
  computed : {
    availableRegimes() {
      const array = []
      array.push({'label': 'Sélectionner', 'value': ''})
      for(const regime of Object.keys(this.regimes)) {
        array.push(
            {
              'label': regime,
              'value': regime
            }
        )
      }
      console.debug('[RegimeSelectForm]', 'availableRegimes', array)
      return array
    },
    availableActivites() {
      const array = []
      if (Object.keys(this.regimes).length > 0 && this.regime) {
        array.push({'label': 'Sélectionner', 'value': ''})
        for(const activite of Object.keys(this.regimes[this.regime])) {
          array.push(
              {
                'label': activite,
                'value': activite
              }
          )
        }
      }
      console.debug('[RegimeSelectForm]', 'availableActivites', array)
      return array
    },
    availableProfessions() {
      const array = []
      if (this.regime && this.activite && (Object.keys(this.regimes).length > 0) && (Object.entries(this.regimes[this.regime][this.activite]).length >= 0)) {
        if (Object.entries(this.regimes[this.regime][this.activite]).length > 1) {
          array.push({'label': 'Sélectionner', 'value': ''})
        }
        for(const profession of Object.entries(this.regimes[this.regime][this.activite])) {
          array.push(
              {
                'label': profession[0],
                'value': profession[0]
              }
          )
        }
      }
      console.debug('[RegimeSelectForm]', 'availableProfessions', array)
      return array
    },
  },
  watch: {
    serverErrors () {
      console.debug('[RegimeSelectForm] ', 'watch', 'serverErrors')
      this.v$.$reset()
      this.v$.$touch()
    },
    regime (value) {
      console.debug('[RegimeSelectForm]', 'watch', 'regime', value)
      this.$emit('updateActivite', '')
    },
    activite (value) {
      console.debug('[RegimeSelectForm]', 'watch', 'activite', value)
      if (this.availableProfessions[0]) {
        this.$emit('updateProfession', this.availableProfessions[0].value)
      } else {
        this.$emit('updateProfession', '')
      }
    }
  },
}
</script>

<style scoped>

</style>
